import { render, staticRenderFns } from "./SimpleInfoModal.vue?vue&type=template&id=13bc7f76&scoped=true&"
import script from "./SimpleInfoModal.vue?vue&type=script&lang=js&"
export * from "./SimpleInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./SimpleInfoModal.vue?vue&type=style&index=0&id=13bc7f76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bc7f76",
  null
  
)

export default component.exports